import gql from 'graphql-tag';

import { EVENT_FRAGMENT } from '../../fragments/event.fragment';

export const RE_DATE_EVENT_ACTIVITIES_TO_DATE = gql`
  mutation ReDateEventActivitiesToDate($input: ReDateEventsToDateInput!) {
    dealActivity {
      result: reDateEventsToDate(input: $input) {
        error
        success
        list {
          __typename
          ...EventFields
        }
      }
    }
  }
  ${EVENT_FRAGMENT}
`;
